import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer>
      <div className="row container py-3">
        <div className="footer-section col-xs-12 col-sm-6 col-md-6 col-lg-3">
          <div className="logo mt-1 mb-50">
            <Link className="text-white" to="/" href="/">
              wedevelopers
            </Link>
          </div>
          <p className="mb-2">Hire the best developer</p>
          <div>
            <h6 className="font-sm">Connect with us</h6>
            <a className="text-white mr-1" href="#">
              <i className="fab fa-twitter"></i>
            </a>
            <a className="text-white mr-1" href="#">
              <i className="fab fa-facebook-f"></i>
            </a>
            <a className="text-white mr-1" href="#">
              <i className="fab fa-linkedin-in"></i>
            </a>
          </div>
        </div>

        <div className="footer-section col-xs-12 col-sm-6 col-md-6 col-lg-3">
          <h5 className="mt-1 mb-50 font-weight-bolder font-medium text-white">
            Hire Developer
          </h5>
          <div>
            <div className="row">
              <div className="col-6 mr-1">
                <ul className="navbar-nav">
                  <li className="mb-50">
                    <a
                      className="text-white text-capitalise nospace"
                      href="/hire/react">
                      React developer
                    </a>
                  </li>
                  <li className="mb-50">
                    <a
                      className="text-white text-capitalise nospace"
                      href="/hire/frontend">
                      Frontend developer
                    </a>
                  </li>
                  <li className="mb-50">
                    <a
                      className="text-white text-capitalise nospace"
                      href="/hire/backend">
                      Backend developer
                    </a>
                  </li>
                  <li className="mb-50">
                    <a
                      className="text-white text-capitalise nospace"
                      href="/hire/python">
                      Python developer
                    </a>
                  </li>
                  <li className="mb-50">
                    <a
                      className="text-white text-capitalise nospace"
                      href="/hire/php">
                      php developer
                    </a>
                  </li>
                  <li className="mb-50">
                    <a
                      className="text-white text-capitalise nospace"
                      href="/hire/vue">
                      vue developer
                    </a>
                  </li>
                </ul>
              </div>
              <div className="col-6">
                <ul className="navbar-nav">
                  <li className="mb-50">
                    <a
                      className="text-white text-capitalise nospace"
                      href="/hire/c">
                      c developer
                    </a>
                  </li>
                  <li className="mb-50">
                    <a
                      className="text-white text-capitalise nospace"
                      href="/hire/ruby">
                      ruby developer
                    </a>
                  </li>
                  <li className="mb-50">
                    <a
                      className="text-white text-capitalise nospace"
                      href="/hire/angular">
                      angular developer
                    </a>
                  </li>
                  <li className="mb-50">
                    <a
                      className="text-white text-capitalise nospace"
                      href="/hire/python">
                      Python developer
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div className="footer-section col-xs-12 col-sm-6 col-md-6 col-lg-3">
          <h5 className="mt-1 mb-50 font-weight-bolder font-medium text-white">
            Join Our Team
          </h5>
          <ul className="navbar-nav">
            <li className="mb-50">
              <Link className="text-white" to="/employer/signup">
                Hire a Developer
              </Link>
            </li>
            <li className="mb-50">
              <Link className="text-white" to="/employer/signup">
                Build your product
              </Link>
            </li>
            <li className="mb-50">
              <Link className="text-white" to="/developer/signup">
                Become a Developer
              </Link>
            </li>
          </ul>
        </div>

        <div className="footer-section col-xs-12 col-sm-6 col-md-6 col-lg-3">
          <h5 className="mt-1 mb-50 font-weight-bolder font-medium text-white">
            Company
          </h5>
          <ul className="navbar-nav">
            <li className="mb-50">
              <Link className="text-white" to="/about">
                About Us
              </Link>
            </li>
            <li className="mb-50">
              <Link className="text-white" to="/blog">
                Blog
              </Link>
            </li>
            <li className="mb-50">
              <a className="text-white" href="/#how-it-works">
                How it works
              </a>
            </li>
            <li className="mb-50">
              <Link className="text-white" to="/contact">
                Contact Us
              </Link>
            </li>
          </ul>
        </div>
      </div>
      <div className="row justify-content-between no-gutters mx-1 py-2 border-top">
        <p className="col-sm-12 col-md-6">© Copyright 2021 wedevelopers</p>
        <div className="col-sm-12 col-md-3">
          <a className="text-white mr-2" href="/privacy">
            Privacy policy
          </a>
          <a className="text-white" href="/terms">
            Terms of service
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
